import { fundamentalsRequest } from './actions';

export const defaultState = {};

const fundamentals = (state = defaultState, action) => {
  switch (action.type) {
    case fundamentalsRequest.event.success: {
      const { accountNumber, data } = action.payload;

      return {
        ...state,
        [accountNumber]: data
      };
    }
    default:
      return state;
  }
};

export default fundamentals;
